var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line-subscribe py-4"},[_c('line-button',{staticClass:"line-subscribe__button",on:{"click":_vm.onSubscribe}},[_vm._v(_vm._s(_vm.$t('common.action.subscribeLine')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }